var exports = {
  "M": "xf0b3b88a--1f7834--image_wrp",
  "a": "xf0b3b88a--1f7834--shield",
};

module.exports = exports;
